$(document).ready(function(){

//   $.get("https://www.cloudflare.com/cdn-cgi/trace", function(data) {     
//     var ip_address = data.split('\n')[2].substring(3);   
//     console.log("ip_address="+ip_address);
//     $.getJSON("https://ipgeolocation.abstractapi.com/v1/?api_key=03af250bd0ad46f8abda91051d35dd76&ip_address=" + ip_address, function(data) {          
//       console.log(data.ip_address);         
//       console.log(data.country);     
//     }) 
//   })
  
  $.get("https://www.cloudflare.com/cdn-cgi/trace", function(data) {     
    var ip_address = data.split('\n')[2].substring(3);   
    console.log("ip_address="+ip_address);
    $.getJSON("https://ipgeolocation.abstractapi.com/v1/?api_key=03af250bd0ad46f8abda91051d35dd76&ip_address=" + ip_address, function(data) {          
  console.log(data.ip_address);         
      console.log(data.country);
    if(data.country == 'United States'){
      //alert("ok");
      var now = new Date();
      now.setDate(now.getDate()+5);
      var getyear = now.getFullYear();
      var getdate = now.getDate() ;
      //var getmonth = now.getMonth() + 1;
      //var nowdatapeend = getmonth+'/'+getdate+'/'+getyear ;
      
       Date.prototype.monthNames = [
        "January", "February", "March",
        "April", "May", "June",
        "July", "August", "September",
        "October", "November", "December"
     ];

     Date.prototype.getMonthName = function() {
        return this.monthNames[this.getMonth()];
     };
     Date.prototype.getShortMonthName = function () {
        return this.getMonthName().substr(0, 3);
     };
      
      //alert('dffdf');
      
      var getmonth = now.getShortMonthName();
      
       var sup = "";
      if (getdate == 1 || getdate == 21 || getdate ==31)
         {
         sup = "st";
         }
      else if (getdate == 2 || getdate == 22)
         {
         sup = "nd";
         }
      else if (getdate == 3 || getdate == 23)
         {
         sup = "rd";
         }
      else
         {
         sup = "th";
         }
      
    //  var nowdatapeend = getmonth+'. '+getdate+sup+', '+getyear ;
      var nowdatapeend = getmonth+'&nbsp;'+getdate+sup ;
      
      
      
          
      var nowlast = new Date();
      nowlast.setDate(nowlast.getDate()+15);
      var getyear1 = nowlast.getFullYear();
      var getdate1 = nowlast.getDate() ;
      //var getmonth1 = nowlast.getMonth() + 1;
      
       //var getmonth1 = nowlast.getMonth() + 1;
      
      
       var sup = "";
      if (getdate1 == 1 || getdate1 == 21 || getdate1 ==31)
         {
         sup = "st";
         }
      else if (getdate1 == 2 || getdate1 == 22)
         {
         sup = "nd";
         }
      else if (getdate1 == 3 || getdate1 == 23)
         {
         sup = "rd";
         }
      else
         {
         sup = "th";
         }
      
      
      
      var getmonth1 = nowlast.getShortMonthName();
      
      //var nowdatapeend1 = getmonth1+'. '+getdate1+sup+', '+getyear1 ;
      
      var nowdatapeend1 = getmonth1+'&nbsp;'+getdate1+sup ;
      
      
      //var nowdatapeend1 = getmonth1+'/'+getdate1+'/'+getyear1 ;
      
      var appenddate = "<img class='gs-truck-icon' src='https://cdn.shopify.com/s/files/1/2469/4153/files/bus.svg?v=1637085838'>Estimated delivery &nbsp;"+nowdatapeend+" - "+nowdatapeend1 ;
      
      var appendline = nowdatapeend+" and "+nowdatapeend1 ;
      
      $( ".gb-single-product-date" ).after( "<div class='appenddatahere'>"+appenddate+"</p>" );
      $( ".gb-single-product-date" ).after( '  <input id="estimated-delivery-date" type="hidden" name="properties[Estimated delivery date]" value="'+appendline+'">' );
      
            $('body').on('DOMSubtreeModified', '#cart-drawer-inner', function() {
      $( ".fg-add" ).after( "<div class='appenddatahere'>"+appenddate+"</p>" );
      $( ".fg-add" ).after( '  <input id="estimated-delivery-date" type="hidden" name="properties[Estimated delivery date]" value="'+appendline+'">' );
      });

      
       var checkmismatch = "no";
      $(".prop_check").each(function(){
        var valcheck = $(this).val();
        var variantid = $(this).attr("data-variant-id");
        var variantqty = $(this).attr("data-quantity");
        var dataline = $(this).attr("data-line");
        var estimateddate = appendline ;
        if(valcheck == nowdatapeend){
        }
        else{
          
          $(this).addClass("dontmatch");
          
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            async:false,
            data:  {
              line: dataline,
              properties: {
                'Estimated delivery date': estimateddate
              }
            },
            dataType: 'json',
            success: function(data) 
            {
              //alert("data-updated");
            }
          });
          
          
        }
      })
      
    }
    else{
      var now = new Date();
      now.setDate(now.getDate()+8);
      console.log("now="+now);
      var getyear = now.getFullYear();
      var getdate = now.getDate() ;
      //var getmonth = now.getMonth() + 1;
      
      
      
      Date.prototype.monthNames = [
        "January", "February", "March",
        "April", "May", "June",
        "July", "August", "September",
        "October", "November", "December"
     ];

     Date.prototype.getMonthName = function() {
        return this.monthNames[this.getMonth()];
     };
     Date.prototype.getShortMonthName = function () {
        return this.getMonthName().substr(0, 3);
     };
      
      
      
      var getmonth = now.getShortMonthName();
      
     // var nowdatapeend = getmonth+'/'+getdate+'/'+getyear ;
       //   console.log("nowdatapeend="+nowdatapeend);
      
      
      
      var sup = "";
      if (getdate == 1 || getdate == 21 || getdate ==31)
         {
         sup = "st";
         }
      else if (getdate == 2 || getdate == 22)
         {
         sup = "nd";
         }
      else if (getdate == 3 || getdate == 23)
         {
         sup = "rd";
         }
      else
         {
         sup = "th";
         }
      
     // var nowdatapeend = getmonth+'. '+getdate+sup+', '+getyear ;
      
      var nowdatapeend = getmonth+'&nbsp;'+getdate+sup;
      
      
      var nowlast = new Date();
      nowlast.setDate(nowlast.getDate()+30);
      var getyear1 = nowlast.getFullYear();
      var getdate1 = nowlast.getDate() ;
      //var getmonth1 = nowlast.getMonth() + 1;
      
      
       var sup = "";
      if (getdate1 == 1 || getdate1 == 21 || getdate1 ==31)
         {
         sup = "st";
         }
      else if (getdate1 == 2 || getdate1 == 22)
         {
         sup = "nd";
         }
      else if (getdate1 == 3 || getdate1 == 23)
         {
         sup = "rd";
         }
      else
         {
         sup = "th";
         }
      
      
      
      var getmonth1 = nowlast.getShortMonthName();
      
      //var nowdatapeend1 = getmonth1+'. '+getdate1+sup+', '+getyear1 ;
      
      var nowdatapeend1 = getmonth1+'&nbsp;'+getdate1+sup ;
      
      var appenddate = "<img class='gs-truck-icon' src='https://cdn.shopify.com/s/files/1/2469/4153/files/bus.svg?v=1637085838'>Estimated delivery &nbsp; "+nowdatapeend+" - "+nowdatapeend1 ;
      
      var appendline = nowdatapeend+" and "+nowdatapeend1 ;
      
      
      $( ".gb-single-product-date" ).after( "<div class='appenddatahere'>"+appenddate+"</p>" );
      $( ".gb-single-product-date" ).after( '  <input id="estimated-delivery-date" type="hidden" name="properties[Estimated delivery date]" value="'+appendline+'">' );
      
            $('body').on('DOMSubtreeModified', '#cart-drawer-inner', function() {
      $( ".fg-add" ).after( "<div class='appenddatahere'>"+appenddate+"</p>" );
      $( ".fg-add" ).after( '  <input id="estimated-delivery-date" type="hidden" name="properties[Estimated delivery date]" value="'+appendline+'">' );
      });
     
      var checkmismatch = "no";
      $(".prop_check").each(function(){
        var valcheck = $(this).val();
        var variantid = $(this).attr("data-variant-id");
        var variantqty = $(this).attr("data-quantity");
        var dataline = $(this).attr("data-line");
        var estimateddate = appendline ;
        if(valcheck == nowdatapeend){
        }
        else{
          
          $(this).addClass("dontmatch");
          
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            async:false,
            data:  {
              line: dataline,
              properties: {
                'Estimated delivery date': estimateddate
              }
            },
            dataType: 'json',
            success: function(data) 
            {
              //alert("data-updated");
            }
          });
          

        }
      })

    
    }

    }) 
  })
})

  
